module.exports = __webpack_public_path__ + "static/media/logo.f8abd45d.svg";